export enum StorageType {
  BOOLEAN = "boolean",
  JSON = "json",
  NUMBER = "number",
  STRING = "string",
}

export type StorageTypes = boolean | number | string | object;
